import { defineMessages } from 'react-intl';

export default defineMessages({
  reservations: {
    id: 'class-list.reservations',
    defaultMessage: 'Reservations',
  },
  enabled: {
    id: 'class-list.enabled',
    defaultMessage: 'Enabled',
  },
  disabled: {
    id: 'class-list.disabled',
    defaultMessage: 'Disabled',
  },
  contractDescription: {
    id: 'classes-list.contract-description',
    defaultMessage:
      'Please only enable services that are approved to be offered on ClassPass. A list of approved services can be found in the <a>Help Center</a>.',
  },
  name: {
    id: 'class-list.name',
    defaultMessage: 'Name',
  },
  bookable: {
    id: 'class-list.bookable',
    defaultMessage: 'Bookable',
  },
});
